import { Award, Banknote, HandHeart, TrendingUp } from "lucide-react";

const Benefits = () => {
  const benefits = [
    {
      icon: Award,
      title: "Profissionais qualificados",
      description: "Arquitetos experientes cuidando de cada detalhe da sua reforma"
    },
    {
      icon: Banknote,
      title: "Facilidade de financiamento",
      description: "Orientação completa para acessar os recursos da Caixa"
    },
    {
      icon: TrendingUp,
      title: "Valorização do seu imóvel",
      description: "Mais conforto, segurança e valorização para sua casa"
    },
    {
      icon: HandHeart,
      title: "Apoio do início ao fim",
      description: "Suporte técnico e humano em todas as etapas da sua obra"
    }
  ];

  return (
    <section 
      className="py-16 md:py-24 relative overflow-hidden"
      style={{
        background: "linear-gradient(135deg, hsl(39 97% 61%), hsl(35 98% 57%))"
      }}
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-white">
            Por que participar?
          </h2>
          
          <p className="text-center text-lg text-white/90 mb-12 max-w-2xl mx-auto">
            Vantagens de fazer parte do programa Minha Casa Mais Bonita
          </p>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div 
                  key={index}
                  className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all hover:scale-105 transform"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] flex items-center justify-center flex-shrink-0">
                      <Icon className="h-7 w-7 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-xl mb-2 text-foreground">{benefit.title}</h3>
                      <p className="text-muted-foreground text-base">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
